import React from "react";
import { mentorNavList, authorNavList, institutionNavList } from "./constant";
import { NavLink } from "react-router-dom";
import styles from "./SideBar.module.css";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { logout as logoutApi } from "../../api/auth";

const SidebarContent = (props) => {
  const navigate = useNavigate();
  // const [isOpen, setIsOpen] = useState(false);
  const { userdata, setAuthModal, logout } = useAuth();
  let menusList = institutionNavList;
  if (userdata?.role === "mentor") menusList = mentorNavList;
  else if (userdata?.role === "author") menusList = authorNavList;
  else if (userdata?.role === "institution") menusList = institutionNavList;
  const changePassoword = () => {
    setAuthModal({ open: true, tab: "changePassword" });
  };
  const logoutHandler = async (e) => {
    try {
      const response = await logoutApi({});
      if (response?.status === 200) {
        localStorage.clear();
        navigate("/");
        setAuthModal({ open: true, tab: "login" });
        toast.success("Logout Successfully", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        logout();
        // handleCloseMenu();
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    } catch (error) {
      const message = error.response?.data?.message || "Server error.";
      toast.error(message);
    }
  };
  // const handleCloseMenu = () => setIsOpen(false);

  return (
    <>
      {props.fromNav && (
        <div className={styles.headingwithBorder}>User Links</div>
      )}
      <div className={styles.navitm}>
        {menusList.map((i) => {
          if (i.link) {
            return (
              <NavLink
                key={i.id}
                to={i.link}
                end
                className={({ isActive }) =>
                  isActive ? ` ${styles.activeLink}` : styles.navItem
                }
                onClick={props.fromNav && props.handleCloseMenu}
              >
                {i.icon}
                <span>{i.label}</span>
              </NavLink>
            );
          }
          return (
            <div key={i.id} className={styles.headingwithBorder}>
              {i.label}
            </div>
          );
        })}
      </div>
      <button className={styles.passwordChange} onClick={changePassoword}>
        Change Password
      </button>
      <button className={styles.logoutBtn} onClick={logoutHandler}>
        Logout
      </button>
    </>
  );
};

export default SidebarContent;
